import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QltsUserController from "../../../../services/qlts/qlts-user-controller";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {getSchoolId, getSchoolYear} from "../../../../utils/authority";
import StudentController from "../../../../services/system/student/student-controller";
import GradeManager from "../../../../components/Grade";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import CLBRegisterController from "../../../../services/system/clb-register/clb-register-controller";
import TableHeader from "../../../../components/TableHeader";
import moment from "moment";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {createSearchParams} from "react-router-dom";
import Pagination from "../../../../components/Pagination";
import ServiceOtherController from "../../../../services/system/service-other/service-other-controller";
import ServiceOtherRegisterController
    from "../../../../services/system/service-other-register/service-other-register-controller";
import Utils from "../../../../utils/utils";

class ModalAddStudentToService extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 0,
            pageSize: 100,
            classRoomId: -1,
            classRoomName: "",
            listStudent: [],
            listClassRoom: [],
            listServiceNumber: {},
            listServiceNote: {},
            listData: [],
            content: "",
            studentName: "",
            studentId: -1,
            lockClass: false,
            lockGrade: false,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên sản phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "endDate",
                    name: "Thuế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Số lượng mua",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Chú thích",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({
                listData: nextProps.serviceItems,
                typeObject: nextProps.typeObject,
                valueObject: nextProps.valueObject,
                serviceOtherId: nextProps.serviceOtherId,
                studentName: "",
                studentId: -1,
            },()=>{
                if (this.state.typeObject === "ALL"){
                    this.setState({
                        isAllSchool: true,
                        lockGrade: false,
                        lockClass: false,
                    });
                }else if (this.state.typeObject == "GRADE"){
                    this.setState({
                        lockGrade: true,
                        lockClass: false,
                        isAllSchool: false,
                        gradeId: this.state.valueObject
                    });
                }else if (this.state.typeObject == "CLASS"){
                    let classRoom =  parseInt(this.state.valueObject)
                    this.setState({
                        lockGrade: true,
                        lockClass: true,
                        isAllSchool: false,
                        classRoomId: parseInt(this.state.valueObject)
                    });
                    this.detailClass(classRoom)
                }
            })
        }
    }
    detailClass(classId) {
        ClassRoomController.detail(classId, res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        classRoomName: data.name,
                        gradeId: data.grade,
                    }
                );
                this.state.listClassRoom.push({
                    id: classId,
                    name: data.name,
                })
            } else {
                toast.error(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        });
    }
    componentWillMount() {
        this.getListStudent()
    }
    addStudent = () => {
        if (this.state.studentId < 0){
            toast.warning("Vui lòng chọn học sinh!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let registerItemList = []
            let listId =Object.keys(this.state.listServiceNumber)
            console.log(listId)
            listId.forEach(id => {
                let number = this.state.listServiceNumber[id]
                if (number >0){
                    registerItemList.push({
                        "note": this.state.listServiceNote[id]==undefined?"":this.state.listServiceNote[id],
                        "number": parseInt(number),
                        "serviceItemId": id
                    })
                }
            })
            if (registerItemList.length>0){
                let payload = {
                    studentId: this.state.studentId,
                    content: this.state.content,
                    serviceOtherId: this.state.serviceOtherId,
                    registerItemList: registerItemList,
                    yearId: parseInt(getSchoolYear())
                }
                ServiceOtherRegisterController.create(payload, res => {
                    if (res.success) {
                        toast.success("Thêm dịch vụ cho học sinh thành công!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        });
                        this.props.onHide();
                        this.props.onRefresh()
                    } else {
                        toast.warning(res.message[0], {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000
                        });
                    }
                })
            }else {
                toast.warning("Vui lòng chọn số lượng sản phẩm muốn mua!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }

        }

    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: this.state.classRoomId,
            code: "",
            ethnic: "",
            fullName: this.state.studentName,
            gender: "",
            grade: this.state.gradeId,
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListService();
            }
        );
    };
    render() {
        let {gradeId, listData, header} = this.state
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered modal-normal">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm sản phẩm cho học sinh</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-4 label-item pl-0">Chọn khối</label>
                                    <GradeManager
                                        gradeId={gradeId}
                                        isLock={this.state.lockGrade}
                                        onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-4 label-item pl-0">Chọn lớp</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.classRoomId}
                                        disabled={this.state.lockClass}
                                        onChange={(e) => {
                                            this.state.classRoomId = e.target.value;
                                            this.setState({
                                                classRoomId: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="-1">Chọn lớp</option>
                                        {this.renderClassRoom()}
                                    </select>
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-2 label-item pl-0">Chọn học sinh(<span  style={{color: "red",}}>*</span>)</label>
                                    <Autocomplete
                                        size="small"
                                        options={this.state.listStudent}
                                        getOptionLabel={option => option.fullName?option.fullName:""}
                                        style={{width: '100%'}}
                                        inputValue={this.state.studentName}
                                        renderInput={params => {
                                            return <TextField
                                                placeholder='Nhập tên học sinh'
                                                {...params}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        fontSize: 17,
                                                        backgroundColor: "#FFF",
                                                        paddingRight: 10,
                                                        paddingLeft: 10,
                                                        color: '#2e495c',
                                                        fontWeight: 500,
                                                        fontFamily: 'Montserrat'
                                                    }
                                                }}
                                                label=""
                                                variant="outlined"
                                                fullWidth
                                            />
                                        }}
                                        onInputChange={(event, val) => {
                                            if (event !== null){
                                                this.setState({
                                                    studentName: val
                                                })
                                                if (val === ""){
                                                    this.state.studentId = -1;
                                                }
                                            }
                                        }}
                                        onChange={(e, val) => {
                                            if (val?.id != undefined){
                                                this.setState({
                                                    studentId: val?.id,
                                                    studentName: val?.fullName,
                                                })
                                            }else {
                                                this.setState({
                                                    studentId: -1,
                                                    studentName: "",
                                                })
                                            }
                                            // this.getListPeopleInCharge()
                                        }}

                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-2 label-item pl-0">Ghi chú</label>
                                    <input
                                        placeholder="Ghi chú"
                                        maxLength={255}
                                        type="text"
                                        className="form-control shadow-none"
                                        value={this.state.content}
                                        onChange={(event) => {
                                            this.setState({
                                                content: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0"><b>Danh sách sản phẩm thuộc dịch vụ</b></label>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.price)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {row.tax}%
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                <input
                                                                    placeholder="Số lượng mua"
                                                                    type="number"
                                                                    className="form-control shadow-none"
                                                                    value={this.state.listServiceNumber[row.id]}
                                                                    onChange={(event) => {
                                                                        this.state.listServiceNumber[row.id] = event.target.value
                                                                        this.setState(this.state.listServiceNumber)
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <input
                                                                    placeholder="Ghi chú: Size, màu,.."
                                                                    maxLength={255}
                                                                    type="text"
                                                                    className="form-control shadow-none"
                                                                    value={this.state.listServiceNote[row.id]}
                                                                    onChange={(event) => {
                                                                        this.state.listServiceNote[row.id] = event.target.value
                                                                        this.setState(this.state.listServiceNote)
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.addStudent()}
                                >
                                        <span className='justify-content-center'>
                                            Thêm
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalAddStudentToService
